import styled from 'styled-components'
import Icon from '@mdi/react'
import theme from 'theme_'

export const DeleteIcon = styled(Icon)<{ disabled?: boolean }>`
  color: ${(p) =>
    p.disabled ? theme.colors.disabledGrey : theme.colors.horizonOrange};

  :hover {
    opacity: ${(p) => (p.disabled ? 1 : 0.8)};
  }
`
